import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { FilterDto } from '../../../types/FilterDto';
import i18n from '../../../i18n';

export const getFilters = async (): Promise<FilterDto[]> => {
    const response = await fetchApi.get<FilterDto[]>('/surveys/filters');
    return response;
};

type QueryFnType = typeof getFilters;

type UseFiltersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useFilters = (config?: UseFiltersOptions) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["filters", i18n.language],
    queryFn: () => getFilters(),
  });